export default {
  apiUrl: "http://localhost:2048/",
  appTitle: "Déliasse",
  appUrl: "http://localhost:3000/",
  twitterName: "#BureauOuvert",
}



//////////////////
// WEBPACK FOOTER
// ./config/global.js
// module id = 116
// module chunks = 0